import React from "react";

import { Menu } from "@mui/material";
import styled from "@mui/material/styles/styled";

import Button, { ButtonProps } from "@rui/Button";

export const ShareButton = styled<React.FC<ButtonProps>>((props) => (
  <Button variant="text" {...props} />
))(({ theme }) => ({
  height: "24px",
  color: theme.palette.shades.neutral[800],
  fontSize: "0.75rem",
  fontWeight: 400,
  minWidth: "fit-content",
  padding: theme.spacing(1),
  borderRadius: theme.corners.base,
  "& .MuiButton-startIcon": {
    marginLeft: 0,
    marginRight: theme.spacing(0.5),
    "& svg": {
      fontSize: "12px",
    },
  },
  "&:hover": {
    backgroundColor: theme.palette.shades.ghost[500],
    color: theme.palette.shades.primary[500],
  },
}));

export const ActionsMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: theme.corners.base,
  },
  "& .MuiList-root": {
    padding: theme.spacing(1),
  },
}));
